import * as types from "./types";
import createReducer from "../../utils/createReducer";
import initialState from './initialState';

let reducersMap = {
   [types.FETCH_CAST_MEMBERS_LIST_START]: (state, action) => {
      const { isFetchingByFilter, isFetchingNextPage } = action.payload

      let newState = {
         isFetchingList: !isFetchingByFilter && !isFetchingNextPage,
         isFetchingByFilter: isFetchingByFilter,
         isFetchingNextPage: isFetchingNextPage,
      }

      return {
         ...state,
         ...newState,
      }
   },

   [types.FETCH_CAST_MEMBERS_LIST_COMPLETED]: (state, action) => {
      const { list, isFetchingNextPage } = action.payload

      let newState = {
         isFetchingList: false,
         isFetchingByFilter: false,
         isFetchingNextPage: false,
      }

      if(isFetchingNextPage) {
         newState.list = {
            ...list,
            data: [...state.list.data, ...list.data],
         }
      } else {
         newState = {
            ...newState,
            list: { ...list },
         }
      }

      return {
         ...state,
         ...newState,
      }
   },
   [types.SET_IS_FETCHING_CAST_MEMBER_DETAILS]: (state, action) => {

      return {
         ...state,
         isFetchingCastMemberDetails: action.payload,
      }
   },
}

export default createReducer(initialState)(reducersMap);
